export default {"src":"/_next/static/media/icon-enerflo-docflo-document-timing.66cca2c7.svg","height":132,"width":122};